<template>
  <div class="panel">
    <div class="panel-head">
      <div>
        <div class="panel-title">{{ $t('chi119') }}</div>
        <div class="subtitle">{{ $t('chi109') }}</div>
      </div>
    </div>
    <div style="overflow: auto">
      <el-table :data="paged" style="width: 100%" size="small" :empty-text="$t('chi9')">
        <el-table-column prop="name" :label="$t('chi90')" min-width="160">
          <template slot-scope="{ row }"><b>{{ row.name }}</b></template>
        </el-table-column>
        <el-table-column :label="$t('chi121')" width="100">
          <template slot-scope="{ row }">{{ fmt(row.number, 0) }}</template>
        </el-table-column>
        <el-table-column :label="$t('chi123')" width="80">
          <template slot-scope="{ row }">{{ percent(row.number) }}%</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-actions">
      <el-pagination
        v-if="sorted.length > pageSize"
        small
        layout="total, prev, pager, next"
        :total="sorted.length"
        :page-size="pageSize"
        :current-page.sync="page"
      ></el-pagination>
      <button type="button" class="btn-soft" @click="handleExport">{{ $t('chi62') }}</button>
    </div>
  </div>
</template>

<script>
import { fmt, exportExcel } from "./statUtils.js";

export default {
  name: "ProgramTable",
  props: {
    // getPlayHistoryStatistics / getHistoryMediaStatistics 返回 [{name, number}]
    list: { type: Array, default: () => [] },
    // 素材视图（区分导出文件名）
    media: { type: Boolean, default: false },
  },
  data() {
    return {
      page: 1,
      pageSize: 10, // 前端分页，每页 10 条
    };
  },
  computed: {
    sorted() {
      return [...this.list].sort((a, b) => b.number - a.number);
    },
    paged() {
      const start = (this.page - 1) * this.pageSize;
      return this.sorted.slice(start, start + this.pageSize);
    },
    total() {
      return this.sorted.reduce((s, p) => s + Number(p.number || 0), 0);
    },
  },
  watch: {
    // 查询/切换节目素材时回到第一页
    list() {
      this.page = 1;
    },
  },
  methods: {
    fmt,
    percent(n) {
      if (this.total <= 0) return 0;
      return Math.round((n / this.total) * 100);
    },
    handleExport() {
      const rows = [
        [this.$t("chi90"), this.$t("chi121"), `${this.$t("chi123")}(%)`],
        ...this.sorted.map((p) => [
          p.name,
          p.number,
          this.percent(p.number),
        ]),
      ];
      exportExcel(rows, this.media ? "Kares_Media_Statistics.xlsx" : "Kares_Program_Statistics.xlsx");
      this.$msg({ message: this.$t("chi147"), type: "success", showClose: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.panel {
  background: #fff;
  border: 1px solid #dcecf4;
  border-radius: 15px;
  box-shadow: 0 8px 28px rgba(31, 142, 190, 0.08);
  overflow: hidden;
}
.panel-head {
  padding: 16px 18px;
  border-bottom: 1px solid #dcecf4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.panel-title {
  font-weight: 800;
  font-size: 16px;
  color: #314356;
}
.subtitle {
  margin-top: 5px;
  color: #7f93a6;
  font-size: 14px;
}
.btn-soft {
  background: #eef9fd;
  color: #0c9ed7;
  border: 1px solid #d3edf7;
  border-radius: 9px;
  padding: 6px 14px;
  min-height: 30px;
  cursor: pointer;
  font: inherit;
}
.empty {
  text-align: center;
  color: #909399;
  font-size: 14px;
  padding: 24px 0;
}
.footer-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 16px;
}
</style>
